import Vue from 'vue'
import VueRouter from 'vue-router'
import main from '../views/Main.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: main
  }
]

const router = new VueRouter({
  routes,
})
router.beforeEach((to, _from, next) => {
  store.dispatch("setActualRoute", to.name)
  next()
})
export default router
